import Swal from 'sweetalert2'

export const getDiffDays = (date1, date2) => {

    if (!(date1 instanceof Date) || !(date2 instanceof Date)) {
        return -1;
    }

    return Math.abs(date1 - date2) / (1000 * 3600 * 24)

}

export const isDateExpired = (expirationDate) => {

    return expirationDate < Math.round(Date.now() / 1000)

}

export const generateRandomCode = (length = 32) => {
    let codigo = '';
    const caracteres = '0123456789abcdefghijklmnopqrstuvwxyz';

    for (let i = 0; i < length; i++) {
        const indiceAleatorio = Math.floor(Math.random() * caracteres.length);
        codigo += caracteres.charAt(indiceAleatorio);
    }

    return codigo;
}

export const getHapIdentifier = (length = 16) => {
    let id = 'C';
    const caracteres = '0123456789';

    for (let i = 0; i < length; i++) {
        const indiceAleatorio = Math.floor(Math.random() * caracteres.length);
        id += caracteres.charAt(indiceAleatorio);
    }

    return id;
}

export const getRepIdentifier = (length = 16) => {
    let id = 'R';
    const caracteres = '0123456789';

    for (let i = 0; i < length; i++) {
        const indiceAleatorio = Math.floor(Math.random() * caracteres.length);
        id += caracteres.charAt(indiceAleatorio);
    }

    return id;
}

export const isCurrencyLocalFormat = (currency) => {
    return !currency || /^\d{1,3}(\.\d{3})*(,\d{1,2})?$/.test(currency); // || /^\d*(,\d{1,2})*$/.test(currency);
}

export const convertCurrencyToDDBB = (currency) => {
    const withoutDots = currency.replace(/\./g, '');
    const withDecimalDot = withoutDots.replace(',', '.');

    return withDecimalDot
}

export const convertCurrencyFromDDBB = (currency) => {
    const withDecimalComma = String(currency).replace('.', ',');
    const withThousandsDots = withDecimalComma.replace(/\B(?=(\d{3})+(?!\d))/, '.');

    return withThousandsDots
}

export const areArraysEqual = (array1, array2) => {
    if (array1.length !== array2.length) return false

    return array1.every((obj, index) => Object.keys(obj).every(key => obj[key] === array2[index][key]))
}

export const userNotification = (type, title, text, timer) => {
    Swal.fire({
        type,
        title,
        text,
        timer
    })
}


// WEBPACK FOOTER //
// ./src/tools/Utils.js